export default __webpack_public_path__ + "static/media/service-2.4df1dca7.svg";